export const TODO_LIST = 'To do list ';
export const SPONSORS = 'Sponsors';
export const TABLES_SOLD = 'Tables committed';
export const UNKNOWN_GUSTS = 'Unknown Guests';
export const SPECIAL_MEALS = 'Special meals';
export const SPECIAL_MEAL = 'Special meal';
export const AUCTION_ITEMS = 'Auction items';
export const CHECKED_IN = 'Checked in';
export const CHECKED_IN_DASH = 'Checked-in';
export const CHECK_IN = 'Check-in';
export const COLLECTED = 'Collected';
export const OUTSTANDING = 'Outstanding';
export const TOTAL_AMOUNT = 'Total amount';
export const MONEY_RAISED = 'Money Raised';
export const TABLES_SALES = 'Table Sales';
export const AUCTION = 'Auction';
export const ACTIVITY = 'Activity';
export const FOUND_THE_MISSION = 'Fund the Mission';
export const TOTAL_RAISED = 'Total Raised';
export const NEEDS_ATTENTION = 'Needs Attention';
